<template>
  <v-btn text @click="addItemAction" min-width="100%">
    <v-icon color="#ffffff">mdi-plus-circle-outline</v-icon>
  </v-btn>
</template>x

<script>

export default {
  name: "CheckListAddItemButton",
  data: () => ({
  }),
  methods: {
    addItemAction() {
      this.$emit('addItemAction')
    }
  },
  created() {
  },
  components: {
  },
  props: []
};

</script>

<style scoped>
</style>
